<template>
  <div
    :class="{ 'cat-repeater-child': true, selected: selected }"
    role="listitem"
    :aria-label="childCaption"
    :data-label="childCaption"
  >
    <slot name="summary"></slot>
    <slot v-if="selected" name="detail"></slot>
    <div class="expando-details">
      <slot name="expandodetails"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatRepeaterChild",
  props: {
    id: {
      type: [String, Number],
      description: "Repeater child ID."
    },
    selected: {
      type: Boolean,
      description: "Zero-based index of the currently selected record."
    },
    editable: {
      type: Boolean,
      description: "Not in use."
    },
    allowEdit: {
      type: Boolean,
      default: true,
      description: "Not in use."
    },
    allowDelete: {
      type: Boolean,
      default: true,
      description: "Not in use."
    },
    allowView: {
      type: Boolean,
      default: false,
      description: "Not in use."
    },
    editButtonLabel: {
      type: String,
      default: "Edit",
      description: "Not in use."
    },
    deleteButtonLabel: {
      type: String,
      default: "Delete",
      description: "Not in use."
    },
    doneButtonLabel: {
      type: String,
      default: "Done",
      description: "Not in use."
    },
    viewButtonLabel: {
      type: String,
      default: "View",
      description: "Not in use."
    },
    childCaption: {
      type: String,
      default: "Record",
      description:
        "Accessible name to identify the child record. Use to target the child container on tests."
    }
  },

  methods: {
    handleDelete: function (event) {
      this.$emit("ui-repeater-delete", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleEdit: function (event) {
      this.$emit("ui-repeater-edit", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleView: function (event) {
      this.$emit("ui-repeater-view", {
        event: event,
        id: this.id ? this.id : null
      });
    },
    handleDone: function (event) {
      this.$emit("ui-repeater-done", {
        event: event,
        id: this.id ? this.id : null
      });
    }
  }
});
</script>
